import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Overlay from 'react-toolbox/lib/overlay'
import Portal from 'react-toolbox/lib/hoc/Portal'
import { Flex, Box } from 'reflexbox'
import T from 'i18n-react'
import { onEnter } from 'helpers/events'
import {
  withProps,
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withStateHandlers,
} from 'recompose'

import notifyHoc from 'containers/App/Notification/Notify'
import Dropdown from './Dropdown'
import Autocomplete from './Autocomplete'
import Button from './Button'
import Title from 'components/typography/title'

import styles from './styles.scss'

const withStyle = CSSModules(styles)

const WrappedDropdown = (props) => (
  <div>
    <Dropdown {...props}/>
  </div>
)

const NotifyDropdown = compose(
  branch(
    ({ disabled }) => !disabled,
    renderComponent(Dropdown)
  ),
  notifyHoc
)(WrappedDropdown)

const Menu = ({
  onInputChange,
  inputValue,
  inputSource,
  onDropdownChange,
  dropdownValue,
  dropdownEnabled,
  onClick,
  onKeyPress,
  onFocus
}) => (
	<div styleName='menu'>
    <Flex column align='center'>
      <Title theme={styles}>
        Options
      </Title>
      <Autocomplete
        keepFocusOnChange
        onFocus={onFocus}
        onQueryChange={onInputChange}
        onChange={onKeyPress}
        label='Filter...'
        value={inputValue}
        source={inputSource}
      />
      <NotifyDropdown
        message={T.translate('pages.project.search.notification.disabled_sort')}
        label='Sort By...'
        onChange={onDropdownChange}
        value={dropdownValue}
        disabled={!dropdownEnabled}
        source={[
          { label: 'Ascending', value: 'asc' },
          { label: 'Descending', value: 'desc' }
        ]}
      />
      <Box>
        <Button
          primary
          raised
          label='Apply'
          onClick={onClick}
        />
      </Box>
    </Flex>
	</div>
)

// passes initial state when mounted
// when click is applied it will send updates to reducer
const withMenuLifecycle = lifecycle({
  shouldComponentUpdate(nextProps){
    if (nextProps.index !== this.props.index) {
      this.props.onReset()
    }
    return true
  }
})

const withMenuStates = withStateHandlers(
  ({ initialInputValue = '', initialDropdownValue }) => ({
    inputValue: initialInputValue,
    dropdownValue: initialDropdownValue
  }),
  {
    onReset: (_, { initialInputValue = '', initialDropdownValue }) => () => ({
      inputValue: initialInputValue,
      dropdownValue: initialDropdownValue
    }),
    onInputChange: (_, { onChange }) => (inputValue) => {
      onChange(inputValue)
      return ({ inputValue })
    },
    onFocus: ({ inputValue }, { onChange }) => () => onChange(inputValue),
    onDropdownChange: ({ inputValue }, { onClick }) => (dropdownValue) => onClick({
      filter: inputValue,
      sort: dropdownValue
    }),
    onClick: ({ inputValue, dropdownValue }, { onClick }) => () => onClick({
      filter: inputValue,
      sort: dropdownValue
    }),
    onKeyPress: ({ dropdownValue }, { onKeyPress }) => (inputValue) => onKeyPress({
      filter: inputValue,
      sort: dropdownValue
    })
  }
)

const EnhancedMenu = compose(
  branch(
    ({ active }) => !active,
    renderNothing
  ),
  withMenuStates,
  withMenuLifecycle,
  withStyle
)(Menu)

const MenuHeader = props => {
  const {
    inputHeaderSource,
    sortEnabled,
    sortBy,
    value,
    active,
    onHide,
    getMenuStyle,
    columnIndex,
    onKeyPress,
    onClick,
    onChange
  } = props
  return (
    <div style={getMenuStyle()}>
      <EnhancedMenu
        active={active}
        position='topLeft'
        theme={styles}
        dropdownEnabled={sortEnabled}
        initialDropdownValue={sortBy}
        onChange={onChange}
        onClick={onClick}
        onKeyPress={onKeyPress}
        index={columnIndex}
        inputSource={inputHeaderSource}
      />
      <Portal>
        <Overlay
          active={active}
          onClick={() => onHide()}
          onEscKeyDown={() => onHide()}
          theme={styles}
        >
        </Overlay>
      </Portal>
    </div>
  )
}

export default withStyle(MenuHeader)
